// settings
// https://swiperjs.com/swiper-api
/*
    <div
        data-controller="swiper"
        class="swiper" 
        data-carousel-options-value="{ }"
    >
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div>Slide 1</div>
            </div>
            <div class="swiper-slide">
                <div>Slide 2</div>
            </div>
            <div class="swiper-slide">
                <div>Slide 3</div>
            </div>
        </div>

        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
*/

import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules'
//https://swiperjs.com/migration-guide-v10

export default class extends Controller {
    static values = {
        options: Object
    }

    connect() {
        const rawValue = this.optionsValue;
        const defaults = this.defaultOptions;
        const config = {
            modules: [Autoplay, Navigation, Pagination, EffectFade],
            ...this.defaultOptions,
            ...this.optionsValue
        };
        this.swiper = new Swiper(this.element, config);
    }

    disconnect() {
        this.swiper.destroy()
    }

    get defaultOptions() {
        return {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 1000,
            loop: true,
            pagination: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        }
    }
}